import { useEffect, useRef, useState } from "react";
import ApiClass from "../api";
import persistedState from "../persited_store";

function loggedInName() {
  const user = persistedState.user();
  if (!user) return "";
  return (
    [user.firstName, user.lastName].filter(Boolean).join(" ").trim() ||
    user.fullName ||
    user.userName ||
    ""
  );
}

export function ChatBot({ bottom = 96 }) {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [chatId, setChatId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const endRef = useRef(null);
  const inputRef = useRef(null);

  const focusInput = () => {
    requestAnimationFrame(() => inputRef.current?.focus());
  };

  useEffect(() => {
    if (open) focusInput();
  }, [open]);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  const send = async (e) => {
    e.preventDefault();
    const text = input.trim();
    if (!text || loading) return;

    setInput("");
    setMessages((m) => [...m, { from: "user", text }]);
    setLoading(true);
    focusInput();

    try {
      const body = { message: text, chatId };
      if (!chatId) {
        const name = loggedInName();
        if (name) body.name = name;
      }
      const res = await ApiClass.postNodeRequest(
        "chatbot/ask",
        !!persistedState.token(),
        body
      );
      const { status_code, data, message } = res?.data || {};
      if (status_code == 1) {
        if (data?.chatId) setChatId(data.chatId);
        setMessages((m) => [...m, { from: "bot", text: data?.reply || "" }]);
      } else {
        setMessages((m) => [
          ...m,
          { from: "bot", text: message || "Something went wrong." },
        ]);
      }
    } catch {
      setMessages((m) => [
        ...m,
        { from: "bot", text: "Could not reach the server." },
      ]);
    } finally {
      setLoading(false);
      focusInput();
    }
  };

  return (
    <div style={{ ...wrap, bottom }}>
      {open ? (
        <div style={panel}>
          <div style={header}>
            <strong>Chat</strong>
            <button type="button" style={iconBtn} onClick={() => setOpen(false)}>
              ×
            </button>
          </div>
          <div style={list}>
            {messages.map((m, i) => (
              <div key={i} style={m.from === "user" ? userBubble : botBubble}>
                {m.text}
              </div>
            ))}
            {loading && <div style={botBubble}>...</div>}
            <div ref={endRef} />
          </div>
          <form onSubmit={send} style={form}>
            <input
              ref={inputRef}
              style={inputBox}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type a message..."
              autoFocus
            />
            <button
              type="submit"
              style={sendBtn}
              disabled={loading || !input.trim()}
              onMouseDown={(e) => e.preventDefault()}
            >
              Send
            </button>
          </form>
        </div>
      ) : (
        <button type="button" style={fab} onClick={() => setOpen(true)}>
          AI support
        </button>
      )}
    </div>
  );
}

const wrap = {
  position: "fixed",
  right: 16,
  bottom: 96,
  zIndex: 1050,
};

const fab = {
  border: 0,
  borderRadius: 999,
  background: "#0d9488",
  color: "#fff",
  padding: "10px 18px",
  fontWeight: 700,
  boxShadow: "0 4px 12px rgba(0,0,0,.2)",
  cursor: "pointer",
};

const panel = {
  width: 320,
  maxWidth: "calc(100vw - 24px)",
  height: 420,
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 8px 28px rgba(0,0,0,.2)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const header = {
  background: "#0d9488",
  color: "#fff",
  padding: "10px 12px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const iconBtn = {
  border: 0,
  background: "transparent",
  color: "#fff",
  fontSize: 22,
  lineHeight: 1,
  cursor: "pointer",
};

const list = {
  flex: 1,
  overflowY: "auto",
  padding: 12,
  background: "#f8fafc",
  display: "flex",
  flexDirection: "column",
  gap: 8,
};

const botBubble = {
  alignSelf: "flex-start",
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: 10,
  padding: "8px 10px",
  maxWidth: "85%",
  fontSize: 14,
  whiteSpace: "pre-wrap",
};

const userBubble = {
  ...botBubble,
  alignSelf: "flex-end",
  background: "#0d9488",
  color: "#fff",
  border: 0,
};

const form = {
  display: "flex",
  gap: 8,
  padding: 10,
  borderTop: "1px solid #e2e8f0",
};

const inputBox = {
  flex: 1,
  border: "1px solid #cbd5e1",
  borderRadius: 8,
  padding: "8px 10px",
  fontSize: 14,
};

const sendBtn = {
  border: 0,
  borderRadius: 8,
  background: "#0d9488",
  color: "#fff",
  fontWeight: 600,
  padding: "8px 12px",
  cursor: "pointer",
};
